<!-- <lib-breadcrumb *ngIf="breadcrumbCons?.show" [params]="breadcrumbCons?.queryparams"></lib-breadcrumb> -->
<lib-toolbar [tableInfo]="tableData?.tableInfo" [recordData]="masterRecordData" [totalData]="masterTotalData"
  [headers]="tableData?.headers" [downloadOptions]="tableData?.downloadOptions" [headerCons]="headerCons"
  [tableId]="tableId" [metaData]="metaData" [searchFilter]="tableConfig?.searchFilter">

</lib-toolbar>

<!-- Table Start -->

<ng-container *ngIf="tableData != undefined && paginatorOptions != undefined">

  <!-- Table with Infinite Scroll-->
  <div *ngIf="hasInfiniteScroll" [ngClass]="{'user-table': tableId === 'userlist' }" [tableHeaderFixer]="{apply: headerFixerOptions}" #tablefixer
    class="table-responsive card-table table-head-fixed"
    (scrolled)="onScrollDown()">
    <ng-container *ngTemplateOutlet="tableTemplate"> </ng-container>
  </div>

  <!-- Table without Infinite Scroll-->
  <div *ngIf="!hasInfiniteScroll" [tableHeaderFixer]="{apply: headerFixerOptions}" #tablefixer
    class="table-head-fixed">
    <ng-container *ngTemplateOutlet="tableTemplate"> </ng-container>
  </div>

  <lib-footer *ngIf="paginatorOptions != undefined && paginatorOptions?.visible" [recordData]="tableData?.recordData"
    [paginatorOptions]="paginatorOptions">
  </lib-footer>
</ng-container>

<ng-template #tableTemplate>
  <table class="table table-striped table-bordered mb-0" [id]="tableId"
    [ngClass]="tableData?.css?.tableClass">
    <thead class="table-primary" [ngClass]="tableData?.css?.theadClass " lib-header-row [headers]="tableData?.headers"
      [defaultSortOptions]="sortOptions" [indexCons]="indexCons">
    </thead>

    <tbody class="bodyItems" [ngClass]="tableData?.css?.tbodyClass" *ngIf="tableType == 'dataTable'" lib-rows
      (onRowClick)="click($event)" (onOptionClick)="handleOptionClick($event)"
      (onWatchlistClick)="handleWatchlistClick($event)" [recordData]="tableData?.recordData"
      [totalData]="tableData?.totalData" [defaultSortOptions]="sortOptions" [totalCols]="tableData?.totalCols"
      [dataTypes]="tableData?.dataTypes" [paginatorOptions]="paginatorOptions" [noData]="this.noData"
      [clickableDataTypes]="clickableDataTypes" [customTemplates]="customTemplates" [headers]="tableData?.headers"
      [indexCons]="indexCons">
    </tbody>
  </table>
</ng-template>

<!-- Table End-->
